{
  "name": "2026-tiwi-frontend",
  "version": "1.0.0",
  "scripts": {
    "preinstall": "node scripts/ensure-docker.mjs",
    "prestart": "node scripts/ensure-docker.mjs",
    "prebuild-production": "node scripts/ensure-docker.mjs",
    "prebuild-staging": "node scripts/ensure-docker.mjs",
    "prebuild-sw": "node scripts/ensure-docker.mjs",
    "ng": "ng",
    "start": "ng serve",
    "start-docker": "ng serve --host 0.0.0.0",
    "build-production": "node ./node_modules/@angular/cli/bin/ng.js build --base-href / --configuration=production  --output-path=dist/production",
    "build-staging": "node ./node_modules/@angular/cli/bin/ng.js build --base-href / --configuration=staging  --output-path=dist/staging",
    "build-sw": "node ./node_modules/@angular/cli/bin/ng.js build --base-href / --configuration=sw --output-path=dist/sw",
    "test": "ng test",
    "lint": "ng lint",
    "upload-production-sourcemaps": "bugsnag-source-maps upload-browser --overwrite --api-key 0b5010acd124e464cc32cbdd90244644 --app-version $npm_package_version --base-url \"*\" --directory dist/production",
    "upload-staging-sourcemaps": "bugsnag-source-maps upload-browser --quiet --overwrite --api-key 0b5010acd124e464cc32cbdd90244644 --app-version ${npm_package_version}-staging --base-url \"*\" --directory dist/staging",
    "version": "PACKAGE_VERSION=$npm_package_version && echo $PACKAGE_VERSION > VERSION && git add VERSION",
    "postversion": "git push && git push --tags",
    "deploy": "./scripts/deploy.sh",
    "remove": "node -r ./scripts/load-aws-profile.js ./node_modules/.bin/sst remove",
    "unlock": "node scripts/assume-role.js && node -r ./scripts/load-aws-profile.js ./node_modules/.bin/sst unlock",
    "invalidate-cache": "./scripts/invalidate-cache.sh"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.0",
    "@angular/cdk": "^22.1.0",
    "@angular/common": "^22.1.0",
    "@angular/compiler": "^22.1.0",
    "@angular/core": "^22.1.0",
    "@angular/forms": "^22.1.0",
    "@angular/platform-browser": "^22.1.0",
    "@angular/platform-browser-dynamic": "^22.1.0",
    "@angular/router": "^22.1.0",
    "@angular/service-worker": "^22.1.0",
    "@auth0/angular-jwt": "^5.2.0",
    "@bugsnag/js": "^8.0.0",
    "@bugsnag/plugin-angular": "^8.0.0",
    "@fortawesome/fontawesome-pro": "^6.7.2",
    "@hutsix/ngxh6": "^5.1.1",
    "@ng-bootstrap/ng-bootstrap": "~21.0.0",
    "@ng-select/ng-select": "^23.5.1",
    "@openapitools/openapi-generator-cli": "^2.17.0",
    "@popperjs/core": "^2.11.8",
    "@stripe/stripe-js": "^9.0.0",
    "@zxing/browser": "^0.2.1",
    "@zxing/library": "^0.23.0",
    "@zxing/ngx-scanner": "^22.0.1",
    "country-code-lookup": "^0.0.23",
    "currency.js": "^2.0.4",
    "moment-timezone": "^0.5.35",
    "ng-recaptcha-2": "^22.0.1",
    "ngx-dropzone-wrapper": "^13.0.0",
    "ngx-indexed-db": "^11.0.2",
    "ngx-moment": "^6.0.2",
    "ngx-pipes": "^3.2.2",
    "ngx-print": "~1.5.1",
    "ngx-quill": "^31.0.1",
    "ngx-stripe": "^22.9.0",
    "parchment": "^3.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "uuid": "^11.1.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.1.2",
    "@angular-eslint/builder": "^22.5.0",
    "@angular-eslint/schematics": "^22.5.0",
    "@angular/cli": "^22.1.2",
    "@angular/compiler-cli": "^22.1.0",
    "@angular/localize": "^22.1.0",
    "@aws-sdk/client-sts": "^3.1026.0",
    "@bugsnag/source-maps": "^2.0.0",
    "@compodoc/compodoc": "^1.1.11",
    "@types/jasmine": "~3.10.3",
    "@types/node": "^22",
    "angular-eslint": "^22.5.0",
    "eslint": "^9.28.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.6",
    "typescript-eslint": "^8.66.0",
    "jasmine-core": "~4.0.1",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.3.1",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.5.0",
    "nodemon": "^2.0.19",
    "opn": "^6.0.0",
    "prettier": "^3.0.0",
    "sst": "^4.6.11",
    "ts-node": "~10.7.0",
    "typescript": "~6.0.3",
    "yalc": "^1.0.0-pre.53"
  }
}
